module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/b0203-confirm/b0203-confirm.component.css
// module id = ./src/app/b0203-confirm/b0203-confirm.component.css
// module chunks = main